import { render, staticRenderFns } from "./messageManage.vue?vue&type=template&id=47e17e98&scoped=true"
import script from "./messageManage.vue?vue&type=script&lang=js"
export * from "./messageManage.vue?vue&type=script&lang=js"
import style0 from "./messageManage.vue?vue&type=style&index=0&id=47e17e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e17e98",
  null
  
)

export default component.exports